module.exports = __webpack_public_path__ + "img/手机端商品SKU1.4ab574c2.png";